import React, { useState, useEffect } from 'react';
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogFooter,
} from "./ui/dialog"
import { Button } from "./ui/button"
import { Input } from "./ui/input"
import { Label } from "./ui/label"
import { Alert, AlertDescription } from "./ui/alert"
import { Folder, FileText, Loader2 } from 'lucide-react';

const RenameDialog = ({
    open,
    onClose,
    onRename,
    itemType,
    currentName,
    loading = false
}) => {
    const [newName, setNewName] = useState('');
    const [error, setError] = useState('');

    useEffect(() => {
        if (open && currentName) {
            setNewName(currentName);
            setError('');
        }
    }, [open, currentName]);

    const handleSubmit = () => {
        const trimmedName = newName.trim();
        if (!trimmedName) {
            setError('Nama tidak boleh kosong');
            return;
        }

        if (trimmedName === currentName) {
            setError('Nama baru sama dengan nama lama');
            return;
        }

        onRename(trimmedName);
    };

    const handleClose = () => {
        if (!loading) {
            setNewName('');
            setError('');
            onClose();
        }
    };

    return (
        <Dialog open={open} onOpenChange={handleClose}>
            <DialogContent className="sm:max-w-md">
                <DialogHeader>
                    <DialogTitle className="flex items-center gap-2">
                        {itemType === 'folder' ? (
                            <Folder className="h-5 w-5 text-yellow-500" />
                        ) : (
                            <FileText className="h-5 w-5 text-blue-500" />
                        )}
                        Rename {itemType === 'folder' ? 'Folder' : 'File'}
                    </DialogTitle>
                </DialogHeader>

                <div className="space-y-4 py-2">
                    {error && (
                        <Alert variant="destructive">
                            <AlertDescription>{error}</AlertDescription>
                        </Alert>
                    )}

                    <div className="space-y-2">
                        <Label htmlFor="newName">Nama {itemType === 'folder' ? 'Folder' : 'File'} Baru</Label>
                        <Input
                            id="newName"
                            value={newName}
                            onChange={(e) => {
                                setNewName(e.target.value);
                                setError('');
                            }}
                            disabled={loading}
                            onKeyPress={(e) => {
                                if (e.key === 'Enter') handleSubmit();
                            }}
                            autoFocus
                        />
                    </div>
                </div>

                <DialogFooter className="gap-2 sm:gap-0">
                    <Button variant="ghost" onClick={handleClose} disabled={loading}>
                        Batal
                    </Button>
                    <Button onClick={handleSubmit} disabled={loading}>
                        {loading ? (
                            <>
                                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                                Mengubah...
                            </>
                        ) : (
                            'Rename'
                        )}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};

export default RenameDialog;
